import { Injectable, inject, signal } from "@angular/core";
import { Message, MessageSeverity } from "../_models/messages.model";
import { LogService } from "./logging/log.service";

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  logService = inject(LogService);

  #messageSignal = signal<Message | null>(null);

  message = this.#messageSignal.asReadonly();

  showMessage(text: string, severity: MessageSeverity) {
    // log all messages
    switch (severity){
      case 'error' :
        this.logService.error(text);
        break;
      case 'warning':
        this.logService.warn(text);
        break;
      case 'info':
      case 'success':
        this.logService.info(text);
        break;
    }

    this.#messageSignal.set({
      text, severity
    })
  }

  clear() {
    this.#messageSignal.set(null);
  }
}